import { html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import { DraftComponentMixin } from '../common/mixins/DraftComponentMixin.js'
import style from './primitives.css'
import '../visually-hidden/VisuallyHidden.js'

/**
 * The collapsed-pages marker (…) in a composed [Pagination](/components/pagination/).
 * The glyph is decorative; a visually-hidden label gives it meaning for
 * assistive tech. Set `label` to localise it.
 *
 * @status draft
 * @category navigation
 * @lightDom true
 *
 * @cssprop [--n-pagination-gap=var(--n-space-xs)] - Inherited spacing token used by the pagination row.
 */
@customElement('nord-pagination-ellipsis')
export default class PaginationEllipsis extends DraftComponentMixin(LitElement) {
  /** The visually-hidden label announced for the collapsed pages. */
  @property() label = 'More pages'

  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }

  render() {
    return html`
      <span aria-hidden="true">…</span>
      <nord-visually-hidden>${this.label}</nord-visually-hidden>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-pagination-ellipsis': PaginationEllipsis
  }
}
